module.exports = __webpack_public_path__ + "static/media/16.99ab458c.png";